import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../services/auth";

function LoginPage() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");

    const handleLogin = (e) => {
        e.preventDefault();

        // Simulate login success
        login(email)
            .then(() => navigate("/"))
            .catch((err) => {
                alert("Unauthorized, plase fill the valid email to access the site.");
                console.error(err);
            });
    };

    const handleChange = (e) => {
        setEmail(e?.target?.value ?? "");
    };

    return (
        <div className="d-flex align-items-center justify-content-center w-100 vh-100">
            <div className="container">
                <div className="row">
                    <div className="col-10 offset-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                        <div className="d-block w-100 border p-5 rounded-3 bg-white shadow-sm">
                            <div className="d-flex justify-content-center mb-5">
                                <img src="/botnoi.svg" alt="Botnoi Logo" width={120} />
                            </div>
                            <h2 className="mb-3">Login</h2>
                            <form onSubmit={handleLogin}>
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">
                                        Email
                                    </label>
                                    <input type="email" className="form-control" id="email" onChange={handleChange} required />
                                </div>
                                <div className="d-flex justify-content-center">
                                    <button type="submit" className="btn btn-primary w-100">
                                        Login
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoginPage;
